import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';
import { Dice } from './Dice.js';
import { gameConfig } from '../config/gameConfig.js';

export class Grenade extends Dice {
    constructor() {
        // 调用父类构造函数，设置value为-1表示这是一个特殊道具
        super(-1, true);
        this.type = 'grenade';
        this.explosionRadius = 1; // 爆炸范围，单位为格子数
        this.explosionDuration = 1000; // 爆炸动画持续时间（毫秒）
    }

    async createDiceMesh() {
        // 直接调用父类的createDiceMesh方法，不需要重复实现加载逻辑
        return super.createDiceMesh();
    }
    
    // 重写获取模型路径的方法，确保使用手榴弹模型
    getModelPath() {
        return gameConfig.dice.models.bomb;
    }
    
    // 重写处理加载后模型的方法，设置手榴弹特有的旋转角度
    processLoadedModel(model) {
        console.log('【手榴弹】开始处理手榴弹模型，添加特效...')
        // 手榴弹模型需要旋转90度以保持正确朝向
        model.rotation.z = Math.PI / 2;
        model.position.set(0, 0, 0);
    }

    // 重写旋转方法，手榴弹不需要旋转
    async rotate(direction) {
        console.log('手榴弹不支持旋转操作');
        return;
    }

    // 添加爆炸效果方法
    async explode() {
        if (this.isExploding) return;
        
        this.isExploding = true;
        this.explosionStartTime = Date.now();

        // 创建爆炸动画
        const startScale = this.mesh.scale.clone();
        const endScale = startScale.clone().multiplyScalar(1.2);

        return new Promise((resolve) => {
            const animate = () => {
                const progress = (Date.now() - this.explosionStartTime) / this.explosionDuration;

                if (progress >= 1) {
                    this.isExploding = false;
                    resolve();
                    return;
                }

                // 使用缓动函数使动画更平滑
                const easeProgress = 1 - Math.pow(1 - progress, 2);

                // 缩放效果
                const scale = startScale.clone().lerp(endScale, easeProgress);
                this.mesh.scale.copy(scale);

                // 透明度效果
                this.mesh.traverse((node) => {
                    if (node.isMesh && node.material) {
                        node.material.opacity = 1 - easeProgress;
                    }
                });

                requestAnimationFrame(animate);
            };

            animate();
        });
    }
}